export class RequestStoreExportProducts {
    patient = null;
    orderDate = new Date();
    storeConfig = null;
    department = null;
    listProductOrder = null;
}
